module.exports = __webpack_public_path__ + "static/media/Hogar.2918de84.jpg";